export default __webpack_public_path__ + "static/anti-theft-logo-full-8ceae0dc800b75ca4f87188796b32583.png";